<template>
  <div class="insights-performance-highlights-card-skeleton-loading">
    <div class="header">
      <div class="skeleton-item skeleton-item-rounded"></div>
      <div class="skeleton-item skeleton-item-pill"></div>
    </div>
    <div class="body">
      <div
        v-for="i in 4"
        :key="i"
        class="skeleton-item skeleton-item-pill"
      ></div>
    </div>
  </div>
</template>
